export const RESET_UPLOADED_DOCUMENTS =
  'ui:employeeBenefits/RESET_UPLOADED_DOCUMENTS';
